export default {
  actions: {
    nuxtServerInit({ dispatch }, context) {
      dispatch('window/nuxtServerInit')
      dispatch('info/nuxtServerInit', context)
    },
  },
}
